import { Component, Input } from '@angular/core';

/**
 * A small colored dot showing a user's chat status.
 *
 * By default it's laid over the corner of an avatar: put it next to the
 * avatar inside a `.chat-status-avatar` wrapper, which gives it something to
 * position against. With `inline`, it sits in the text flow instead (status
 * pickers, buttons).
 *
 * Shows nothing when the status is unknown (e.g. users that didn't come from
 * a chat payload).
 */
@Component({
    selector: 'chat-status-dot',
    template: require('./chat-status-dot.component.html')
})
export class ChatStatusDotComponent {
    /** One of online, away, busy, offline */
    @Input() status: string | null = null;
    @Input() inline = false;
}
